import React from 'react'

type IconProps = React.HTMLAttributes<SVGElement> & {
	fill?: string
	width?: string
	height?: string
	stroke?: string
}

export const Icons = {
	spinnerCircle: (props: IconProps) => (
		<svg
			width="23"
			height="23"
			viewBox="0 0 23 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle
				cx="11.5"
				cy="11.7007"
				r="10"
				stroke="#07111A"
				strokeOpacity="0.2"
				strokeWidth="2"
			/>
		</svg>
	),
	iconGlobe: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_718_7582)">
				<path
					d="M1.3335 8.00016H14.6668M1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668M1.3335 8.00016C1.3335 4.31826 4.31826 1.3335 8.00016 1.3335M14.6668 8.00016C14.6668 11.6821 11.6821 14.6668 8.00016 14.6668M14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335M8.00016 1.3335C9.66768 3.15906 10.6153 5.52819 10.6668 8.00016C10.6153 10.4721 9.66768 12.8413 8.00016 14.6668M8.00016 1.3335C6.33264 3.15906 5.38499 5.52819 5.3335 8.00016C5.38499 10.4721 6.33264 12.8413 8.00016 14.6668"
					stroke={props.stroke || 'white'}
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_718_7582">
					<rect width="16" height="16" fill={props.fill || 'white'} />
				</clipPath>
			</defs>
		</svg>
	),
	iconClose: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18 6L6 18M6 6L18 18"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCheck: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_52803_70348)">
				<path
					d="M14.6663 7.99967C14.6663 4.31777 11.6815 1.33301 7.99967 1.33301C4.31777 1.33301 1.33301 4.31777 1.33301 7.99967C1.33301 11.6815 4.31777 14.6663 7.99967 14.6663C11.6815 14.6663 14.6663 11.6815 14.6663 7.99967Z"
					stroke="#E02189"
					strokeWidth="1.5"
				/>
				<path
					d="M5.33301 8L7.33301 10L10.6663 6"
					stroke="#E02189"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_52803_70348">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	iconBadge: (props: IconProps) => (
		<svg
			width="33"
			height="33"
			viewBox="0 0 33 33"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21.5 31.75L20.836 32.0986C20.968 32.3501 21.2307 32.5054 21.5146 32.4999C21.7986 32.4943 22.055 32.3289 22.1771 32.0725L21.5 31.75ZM24 26.5V25.75C23.7107 25.75 23.4472 25.9164 23.3229 26.1775L24 26.5ZM29.75 26.5V27.25C30.0266 27.25 30.2807 27.0978 30.4113 26.8539C30.5418 26.61 30.5275 26.3141 30.374 26.084L29.75 26.5ZM25.374 18.584L24.958 17.9599L23.7099 18.792L24.126 19.416L25.374 18.584ZM15.586 22.0986L20.836 32.0986L22.164 31.4014L16.914 21.4014L15.586 22.0986ZM22.1771 32.0725L24.6771 26.8225L23.3229 26.1775L20.8229 31.4275L22.1771 32.0725ZM24 27.25H29.75V25.75H24V27.25ZM30.374 26.084L25.374 18.584L24.126 19.416L29.126 26.916L30.374 26.084Z"
				fill="#1E293B"
			/>
			<path
				d="M11.75 32.25L12.414 32.5986C12.282 32.8501 12.0193 33.0054 11.7354 32.9999C11.4514 32.9943 11.195 32.8289 11.0729 32.5725L11.75 32.25ZM9.25 27V26.25C9.53928 26.25 9.80277 26.4164 9.92715 26.6775L9.25 27ZM3.5 27V27.75C3.2234 27.75 2.96926 27.5978 2.83874 27.3539C2.70823 27.11 2.72253 26.8141 2.87596 26.584L3.5 27ZM7.87596 19.084L8.29199 18.4599L9.54006 19.292L9.12404 19.916L7.87596 19.084ZM17.664 22.5986L12.414 32.5986L11.086 31.9014L16.336 21.9014L17.664 22.5986ZM11.0729 32.5725L8.57285 27.3225L9.92715 26.6775L12.4271 31.9275L11.0729 32.5725ZM9.25 27.75H3.5V26.25H9.25V27.75ZM2.87596 26.584L7.87596 19.084L9.12404 19.916L4.12404 27.416L2.87596 26.584Z"
				fill="#1E293B"
			/>
			<circle cx="16.75" cy="11.25" r="6" stroke="#E02189" strokeWidth="1.5" />
			<circle
				cx="16.75"
				cy="11.25"
				r="10.5"
				stroke="#E02189"
				strokeWidth="1.5"
			/>
		</svg>
	),
	iconLock: (props: IconProps) => (
		<svg
			width="24"
			height="31"
			viewBox="0 0 24 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect
				x="1.56641"
				y="12.375"
				width="21.5"
				height="17"
				rx="2.25"
				stroke="black"
				strokeWidth="1.5"
			/>
			<rect
				x="10.5664"
				y="18.375"
				width="3.5"
				height="6.5"
				rx="1.75"
				stroke="black"
				strokeWidth="1.5"
			/>
			<path
				d="M9.56641 8.125C9.56641 6.60622 10.7976 5.375 12.3164 5.375C13.8352 5.375 15.0664 6.60622 15.0664 8.125V12.375H9.56641V8.125Z"
				stroke="black"
				strokeWidth="1.5"
			/>
			<path
				d="M5.06641 7.625C5.06641 3.89708 8.08848 0.875 11.8164 0.875H12.8164C16.5443 0.875 19.5664 3.89708 19.5664 7.625V12.375H5.06641V7.625Z"
				stroke="black"
				strokeWidth="1.5"
			/>
		</svg>
	),
	save: (props: IconProps) => (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M24.6667 9.68359C27.8827 11.4775 30 14.5325 30 17.9997C30 20.7445 28.673 23.231 26.5244 25.0379C26.2023 25.3089 26 25.7013 26 26.1222V29.333H23.3334L22.275 27.8229C22.1107 27.5885 21.8155 27.4866 21.5383 27.5579C19.2331 28.1506 16.767 28.1506 14.4618 27.5579C14.1846 27.4866 13.8894 27.5885 13.7252 27.8229L12.6667 29.333H10V26.1535C10 25.7151 9.78451 25.3047 9.42356 25.0558C7.99051 24.0678 3.33337 22.1349 3.33337 20.0773V17.9997C3.33337 17.2106 3.93032 16.5711 4.66671 16.5711C5.47557 16.5711 6.13588 16.2569 6.40277 15.4211C7.16168 13.0447 8.94441 11.0162 11.3334 9.68359"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.2946 5.93807C21.1957 5.1754 20.3217 3.94318 18.7501 3.94315C16.924 3.94312 16.1556 4.95642 15.9997 5.46307C15.7565 6.14077 15.8051 7.53407 17.9455 7.68597C20.6211 7.87598 21.6929 8.19238 21.5566 9.83299C21.4201 11.4735 19.9287 11.828 18.7501 11.7899C17.5713 11.752 15.6429 11.2095 15.5681 9.75028M18.563 2.875V3.94678M18.563 11.7801V12.875"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M10.6664 16H10.6784"
				stroke="#1E293B"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	priceAlert: (props: IconProps) => (
		<svg
			width="33"
			height="32"
			viewBox="0 0 33 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M27.2279 18.2627L27.8129 18.8511C28.6586 19.7018 29.1334 20.8527 29.1334 22.0524V22.0524C29.1334 22.5656 28.8475 23.0377 28.3806 23.2448C26.2345 24.1965 22.0342 25.6005 16.3334 25.6005C10.6325 25.6005 6.4322 24.1965 4.28621 23.2448C3.81923 23.0377 3.53339 22.5656 3.53339 22.0524V22.0524C3.53339 20.8527 4.00813 19.7018 4.85392 18.8511L5.43885 18.2627C5.94422 17.7543 6.22812 17.0649 6.22812 16.3461V12.7253C6.22812 7.11144 10.7524 2.56055 16.3334 2.56055C17.0255 2.56055 17.7014 2.63055 18.3544 2.76388"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.8774 7.76055C26.7506 6.78434 25.6297 5.2071 23.6142 5.20706C21.2723 5.20702 20.2869 6.50405 20.087 7.15256C19.775 8.02 19.8374 9.80343 22.5824 9.99786C26.0137 10.2411 27.3883 10.6461 27.2134 12.746C27.0385 14.8459 25.1258 15.2996 23.6142 15.2509C22.1025 15.2023 19.6294 14.5079 19.5334 12.6402M23.3743 3.83984V5.21171M23.3743 15.2383V16.6398"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M20.1734 25.5996C20.1734 27.7204 18.1384 29.4396 15.6574 29.4396C13.1764 29.4396 11.2134 27.7204 11.2134 25.5996"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconMoney: (props: IconProps) => (
		<svg
			width="39"
			height="32"
			viewBox="0 0 39 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.8674 15.012C33.5709 14.7228 33.0961 14.7287 32.8068 15.0251L28.0932 19.8567C27.8039 20.1532 27.8098 20.628 28.1063 20.9173C28.4028 21.2065 28.8776 21.2007 29.1669 20.9042L33.3568 16.6095L37.6515 20.7994C37.948 21.0886 38.4228 21.0828 38.7121 20.7863C39.0013 20.4898 38.9955 20.015 38.699 19.7257L33.8674 15.012ZM7.35772 20.54C7.19825 20.1577 6.75907 19.9771 6.37679 20.1366C5.9945 20.296 5.81387 20.7352 5.97334 21.1175L7.35772 20.54ZM33.3437 15.5489C32.5937 15.5581 32.5937 15.5578 32.5937 15.5576C32.5937 15.5576 32.5937 15.5573 32.5937 15.5573C32.5937 15.5572 32.5937 15.5573 32.5937 15.5576C32.5937 15.5582 32.5937 15.5595 32.5938 15.5615C32.5938 15.5657 32.5938 15.5727 32.5938 15.5827C32.5937 15.6025 32.5934 15.6339 32.5926 15.6759C32.591 15.7601 32.587 15.887 32.5778 16.0511C32.5595 16.3796 32.5201 16.8556 32.4362 17.4338C32.2681 18.593 31.923 20.1477 31.2191 21.7441C29.8231 24.9102 27.022 28.2483 21.2714 29.0168L21.4701 30.5036C27.8479 29.6512 31.0333 25.8836 32.5916 22.3493C33.3649 20.5954 33.739 18.9013 33.9207 17.6491C34.0117 17.0217 34.055 16.5014 34.0755 16.1349C34.0858 15.9516 34.0903 15.8065 34.0923 15.7054C34.0933 15.6549 34.0937 15.6153 34.0937 15.5874C34.0938 15.5735 34.0938 15.5625 34.0937 15.5545C34.0937 15.5505 34.0937 15.5472 34.0937 15.5448C34.0937 15.5435 34.0937 15.5425 34.0936 15.5416C34.0936 15.5412 34.0936 15.5407 34.0936 15.5405C34.0936 15.54 34.0936 15.5396 33.3437 15.5489ZM21.2714 29.0168C16.8345 29.6098 13.708 28.2665 11.5181 26.4139C9.30374 24.5406 8.01544 22.1167 7.35772 20.54L5.97334 21.1175C6.67809 22.807 8.08192 25.4717 10.5493 27.5591C13.0411 29.6671 16.5861 31.1564 21.4701 30.5036L21.2714 29.0168Z"
				fill="black"
			/>
			<path
				d="M5.29974 17.7492C5.59755 18.0371 6.07236 18.0291 6.36024 17.7313L11.0517 12.8781C11.3396 12.5803 11.3315 12.1055 11.0337 11.8176C10.7359 11.5297 10.2611 11.5378 9.97319 11.8356L5.80303 16.1495L1.48913 11.9793C1.19131 11.6914 0.716508 11.6995 0.428618 11.9973C0.140729 12.2951 0.148775 12.7699 0.446587 13.0578L5.29974 17.7492ZM17.7277 2.50305L17.827 3.24644L17.7277 2.50305ZM31.9477 12.5332C32.0945 12.9205 32.5276 13.1154 32.9149 12.9685C33.3022 12.8217 33.4971 12.3887 33.3502 12.0014L31.9477 12.5332ZM5.82101 17.21C6.5709 17.1973 6.5709 17.1976 6.57091 17.1978C6.57091 17.1978 6.57091 17.198 6.57091 17.198C6.57091 17.1981 6.57091 17.198 6.5709 17.1976C6.57089 17.197 6.57088 17.1955 6.57086 17.1933C6.57081 17.1889 6.57076 17.1814 6.57074 17.1709C6.5707 17.1499 6.57079 17.1171 6.5714 17.073C6.57263 16.985 6.57591 16.8523 6.58427 16.6811C6.60101 16.3384 6.638 15.8424 6.71915 15.2401C6.88183 14.0328 7.21989 12.4145 7.91757 10.7551C9.30299 7.4598 12.0908 4.0131 17.827 3.24644L17.6283 1.75966C11.2361 2.61399 8.07062 6.52075 6.53481 10.1737C5.77187 11.9884 5.40733 13.7429 5.23258 15.0398C5.14501 15.6897 5.10458 16.2287 5.08606 16.608C5.07679 16.7977 5.073 16.9478 5.07155 17.0522C5.07082 17.1044 5.07068 17.1452 5.07074 17.1739C5.07077 17.1882 5.07085 17.1995 5.07092 17.2077C5.07096 17.2118 5.071 17.2151 5.07104 17.2176C5.07105 17.2188 5.07107 17.2199 5.07108 17.2207C5.07109 17.2212 5.0711 17.2216 5.0711 17.2219C5.07111 17.2223 5.07111 17.2227 5.82101 17.21ZM17.827 3.24644C22.435 2.63058 25.6442 4.18164 27.8642 6.25049C30.1102 8.34362 31.362 10.9887 31.9477 12.5332L33.3502 12.0014C32.7258 10.3546 31.3716 7.46872 28.8869 5.15314C26.3761 2.81328 22.7297 1.07786 17.6283 1.75966L17.827 3.24644Z"
				fill="black"
			/>
			<path
				d="M24.0488 11.8818C24.0488 10.929 23.7265 10.0621 23.2709 9.31272C21.9313 7.10954 18.9252 7.25942 16.7524 8.64762V8.64762C14.7225 9.94448 15.2273 13.1818 17.4728 14.0535C20.8665 15.3711 24.4193 17.3001 24.5488 19.6318C24.5488 20.8818 23.7988 23.8818 19.5488 23.8818C15.2988 23.8818 15.0488 19.6318 15.0488 19.6318"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19.7988 5.38184V26.3818"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconPin: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.00033 8.66634C9.10489 8.66634 10.0003 7.77091 10.0003 6.66634C10.0003 5.56177 9.10489 4.66634 8.00033 4.66634C6.89576 4.66634 6.00033 5.56177 6.00033 6.66634C6.00033 7.77091 6.89576 8.66634 8.00033 8.66634Z"
				stroke={props.stroke || 'black'}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.95913 13.7305C7.31134 14.0573 7.48745 14.2207 7.70556 14.288C7.89 14.3449 8.11065 14.3449 8.29509 14.288C8.5132 14.2207 8.68931 14.0573 9.04152 13.7305C11.3194 11.6168 13.3337 9.2263 13.3337 6.66634C13.3337 3.72082 10.9458 1.33301 8.00033 1.33301C5.05481 1.33301 2.66699 3.72082 2.66699 6.66634C2.66699 9.2263 4.68123 11.6168 6.95913 13.7305Z"
				stroke={props.stroke || 'black'}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconPinBig: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.99935 8.66659C9.10392 8.66659 9.99935 7.77115 9.99935 6.66659C9.99935 5.56202 9.10392 4.66659 7.99935 4.66659C6.89478 4.66659 5.99935 5.56202 5.99935 6.66659C5.99935 7.77115 6.89478 8.66659 7.99935 8.66659Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.95815 13.7307C7.31036 14.0576 7.48647 14.221 7.70458 14.2883C7.88903 14.3452 8.10967 14.3452 8.29412 14.2883C8.51223 14.221 8.68833 14.0576 9.04054 13.7307C11.3184 11.617 13.3327 9.22654 13.3327 6.66659C13.3327 3.72107 10.9449 1.33325 7.99935 1.33325C5.05383 1.33325 2.66602 3.72107 2.66602 6.66659C2.66602 9.22654 4.68026 11.617 6.95815 13.7307Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	inPolicy: () => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M9 17.625C9.0736 19.4769 10.6169 21.0494 12.6844 20.9988C13.1654 20.9871 13.7599 20.8194 14.9489 20.484C17.8104 19.6769 20.2944 18.3204 20.8904 15.2816C21 14.723 21 14.0944 21 12.8373V11.1627C21 9.90564 21 9.27707 20.8904 8.71848C20.2944 5.67966 17.8104 4.32317 14.9489 3.51603C13.7599 3.18065 13.1654 3.01296 12.6844 3.00119C10.6169 2.95061 9.0736 4.52308 9 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M14 12H3M14 12C14 11.2998 12.0057 9.99153 11.5 9.5M14 12C14 12.7002 12.0057 14.0085 11.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	outPolicy: () => (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
		>
			<path
				d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.9871 10.2401 20.8194 9.05112 20.484C6.18961 19.6769 3.70555 18.3204 3.10956 15.2816C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90564 3 9.27707 3.10956 8.71848C3.70555 5.67966 6.18961 4.32317 9.05112 3.51603C10.2401 3.18065 10.8346 3.01296 11.3156 3.00119C13.3831 2.95061 14.9264 4.52308 15 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconLens: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.5 17.5L22 22"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	lock: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8 11.0003V9.66699"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2.84651 12.5631C2.99643 13.6767 3.91872 14.549 5.04108 14.6006C5.98548 14.644 6.94484 14.6667 8.00131 14.6667C9.05777 14.6667 10.0171 14.644 10.9615 14.6006C12.0839 14.549 13.0062 13.6767 13.1561 12.5631C13.2539 11.8365 13.3346 11.0917 13.3346 10.3333C13.3346 9.57493 13.2539 8.8302 13.1561 8.10353C13.0062 6.99 12.0839 6.11766 10.9615 6.06606C10.0171 6.02265 9.05777 6 8.00131 6C6.94484 6 5.98548 6.02265 5.04108 6.06606C3.91872 6.11766 2.99643 6.99 2.84651 8.10353C2.74867 8.8302 2.66797 9.57493 2.66797 10.3333C2.66797 11.0917 2.74867 11.8365 2.84651 12.5631Z"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
			/>
			<path
				d="M5 5.99967V4.33301C5 2.67615 6.34315 1.33301 8 1.33301C9.65687 1.33301 11 2.67615 11 4.33301V5.99967"
				stroke={props.stroke || '#64748B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCalendarFrom: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.7231 3.51965C10.9855 3.51965 11.2031 3.30205 11.2031 3.03965V1.11965C11.2031 0.857248 10.9855 0.639648 10.7231 0.639648C10.4607 0.639648 10.2431 0.857248 10.2431 1.11965V3.03965C10.2431 3.30205 10.4607 3.51965 10.7231 3.51965Z"
				fill="black"
			/>
			<path
				d="M5.60203 3.51965C5.86443 3.51965 6.08203 3.30205 6.08203 3.03965V1.11965C6.08203 0.857248 5.86443 0.639648 5.60203 0.639648C5.33963 0.639648 5.12203 0.857248 5.12203 1.11965V3.03965C5.12203 3.30205 5.33963 3.51965 5.60203 3.51965Z"
				fill="black"
			/>
			<path
				d="M10.403 9.11958C10.4862 9.11958 10.5694 9.10039 10.6462 9.06839C10.7294 9.03639 10.7934 8.99158 10.8574 8.93398C10.9726 8.81238 11.043 8.64598 11.043 8.47958C11.043 8.31318 10.9726 8.14679 10.8574 8.02519C10.7934 7.96759 10.723 7.92277 10.6462 7.89077C10.4926 7.82677 10.3134 7.82677 10.1598 7.89077C10.083 7.92277 10.0126 7.96759 9.94857 8.02519C9.92297 8.05719 9.89098 8.08918 9.87178 8.12118C9.84618 8.15958 9.82696 8.19798 9.81416 8.23638C9.79496 8.27478 9.78216 8.31317 9.77576 8.35157C9.76936 8.39637 9.76297 8.44118 9.76297 8.47958C9.76297 8.64598 9.83337 8.81238 9.94857 8.93398C10.0126 8.99158 10.083 9.03639 10.1598 9.06839C10.2366 9.10039 10.3198 9.11958 10.403 9.11958Z"
				fill="black"
			/>
			<path
				d="M8.16078 9.11965C8.24398 9.11965 8.32718 9.10046 8.40398 9.06846C8.48718 9.03646 8.55118 8.99165 8.61518 8.93405C8.73038 8.81245 8.80078 8.64605 8.80078 8.47965C8.80078 8.44125 8.79439 8.39644 8.78799 8.35164C8.78159 8.31324 8.76879 8.27485 8.74959 8.23645C8.73679 8.19805 8.71757 8.15965 8.69197 8.12125C8.66637 8.08925 8.64078 8.05726 8.61518 8.02526C8.37838 7.78846 7.94959 7.78846 7.70639 8.02526C7.68079 8.05726 7.65519 8.08925 7.62959 8.12125C7.60399 8.15965 7.58477 8.19805 7.57197 8.23645C7.55277 8.27485 7.53997 8.31324 7.53357 8.35164C7.52717 8.39644 7.52078 8.44125 7.52078 8.47965C7.52078 8.64605 7.59119 8.81245 7.70639 8.93405C7.82799 9.04925 7.98798 9.11965 8.16078 9.11965Z"
				fill="black"
			/>
			<path
				d="M10.403 11.3598C10.4862 11.3598 10.5694 11.3406 10.6462 11.3086C10.723 11.2766 10.7934 11.2318 10.8574 11.1742C10.9726 11.0526 11.043 10.8862 11.043 10.7198C11.043 10.6814 11.0366 10.6366 11.0302 10.5982C11.0238 10.5534 11.011 10.515 10.9918 10.4766C10.979 10.4382 10.9598 10.3998 10.9342 10.3614C10.915 10.3294 10.883 10.2974 10.8574 10.2654C10.7934 10.2078 10.723 10.163 10.6462 10.131C10.4926 10.067 10.3134 10.067 10.1598 10.131C10.083 10.163 10.0126 10.2078 9.94857 10.2654C9.92297 10.2974 9.89098 10.3294 9.87178 10.3614C9.84618 10.3998 9.82696 10.4382 9.81416 10.4766C9.79496 10.515 9.78216 10.5534 9.77576 10.5982C9.76936 10.6366 9.76297 10.6814 9.76297 10.7198C9.76297 10.8862 9.83337 11.0526 9.94857 11.1742C10.0126 11.2318 10.083 11.2766 10.1598 11.3086C10.2366 11.3406 10.3198 11.3598 10.403 11.3598Z"
				fill="black"
			/>
			<path
				d="M2.72203 6.13773H13.602C13.8644 6.13773 14.082 5.92013 14.082 5.65773C14.082 5.39533 13.8644 5.17773 13.602 5.17773H2.72203C2.45963 5.17773 2.24203 5.39533 2.24203 5.65773C2.24203 5.92013 2.45963 6.13773 2.72203 6.13773Z"
				fill="black"
			/>
			<path
				d="M9.44234 14.3996H10.7223C13.0583 14.3996 14.4023 13.0556 14.4023 10.7196V5.27961C14.4023 2.94361 13.0583 1.59961 10.7223 1.59961H5.60234C3.26634 1.59961 1.92234 2.94361 1.92234 5.27961V7.51961C1.92234 7.78201 2.13994 7.99961 2.40234 7.99961C2.66474 7.99961 2.88234 7.78201 2.88234 7.51961V5.27961C2.88234 3.44921 3.77194 2.55961 5.60234 2.55961H10.7223C12.5527 2.55961 13.4423 3.44921 13.4423 5.27961V10.7196C13.4423 12.55 12.5527 13.4396 10.7223 13.4396H9.44234C9.17994 13.4396 8.96234 13.6572 8.96234 13.9196C8.96234 14.182 9.17994 14.3996 9.44234 14.3996Z"
				fill="black"
			/>
			<path
				d="M2.40297 9.60008C2.66537 9.60008 2.88297 9.81768 2.88297 10.0801L2.88297 12.3201C2.88297 12.7617 3.24137 13.1201 3.68297 13.1201L6.56297 13.1201C6.82537 13.1201 7.04297 13.3377 7.04297 13.6001C7.04297 13.8625 6.82537 14.0801 6.56297 14.0801L3.68297 14.0801C2.71017 14.0801 1.92297 13.2929 1.92297 12.3201L1.92297 10.0801C1.92297 9.81768 2.14057 9.60008 2.40297 9.60008Z"
				fill="black"
			/>
			<path
				d="M4.96328 11.5195C5.07208 11.5195 5.18087 11.5579 5.27047 11.6283L7.19047 13.2283C7.29927 13.3179 7.36328 13.4523 7.36328 13.5995C7.36328 13.7467 7.29927 13.8747 7.19047 13.9707L5.27047 15.5707C5.06567 15.7435 4.76487 15.7115 4.59207 15.5067C4.41927 15.3019 4.45129 15.0011 4.65609 14.8283L6.13449 13.5995L4.65609 12.3707C4.45129 12.1979 4.42567 11.8971 4.59207 11.6923C4.68807 11.5771 4.82888 11.5195 4.96328 11.5195Z"
				fill="black"
			/>
		</svg>
	),
	iconCalendarTo: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.7231 3.51965C10.9855 3.51965 11.2031 3.30205 11.2031 3.03965V1.11965C11.2031 0.857248 10.9855 0.639648 10.7231 0.639648C10.4607 0.639648 10.2431 0.857248 10.2431 1.11965V3.03965C10.2431 3.30205 10.4607 3.51965 10.7231 3.51965Z"
				fill="black"
			/>
			<path
				d="M5.60203 3.51965C5.86443 3.51965 6.08203 3.30205 6.08203 3.03965V1.11965C6.08203 0.857248 5.86443 0.639648 5.60203 0.639648C5.33963 0.639648 5.12203 0.857248 5.12203 1.11965V3.03965C5.12203 3.30205 5.33963 3.51965 5.60203 3.51965Z"
				fill="black"
			/>
			<path
				d="M5.92125 9.11958C5.83805 9.11958 5.75485 9.10039 5.67805 9.06839C5.59485 9.03639 5.53086 8.99158 5.46686 8.93398C5.35166 8.81238 5.28125 8.64598 5.28125 8.47958C5.28125 8.31318 5.35166 8.14679 5.46686 8.02519C5.53086 7.96759 5.60125 7.92277 5.67805 7.89077C5.83165 7.82677 6.01085 7.82677 6.16445 7.89077C6.24125 7.92277 6.31164 7.96759 6.37564 8.02519C6.40124 8.05719 6.43324 8.08918 6.45244 8.12118C6.47804 8.15958 6.49726 8.19798 6.51006 8.23638C6.52926 8.27478 6.54206 8.31317 6.54846 8.35157C6.55486 8.39637 6.56125 8.44118 6.56125 8.47958C6.56125 8.64598 6.49084 8.81238 6.37564 8.93398C6.31164 8.99158 6.24125 9.03639 6.16445 9.06839C6.08765 9.10039 6.00445 9.11958 5.92125 9.11958Z"
				fill="black"
			/>
			<path
				d="M8.16344 9.11965C8.08024 9.11965 7.99703 9.10046 7.92023 9.06846C7.83703 9.03646 7.77304 8.99165 7.70904 8.93405C7.59384 8.81245 7.52344 8.64605 7.52344 8.47965C7.52344 8.44125 7.52983 8.39644 7.53623 8.35164C7.54263 8.31324 7.55543 8.27485 7.57463 8.23645C7.58743 8.19805 7.60665 8.15965 7.63225 8.12125C7.65785 8.08925 7.68344 8.05726 7.70904 8.02526C7.94584 7.78846 8.37463 7.78846 8.61783 8.02526C8.64343 8.05726 8.66903 8.08925 8.69463 8.12125C8.72023 8.15965 8.73945 8.19805 8.75225 8.23645C8.77145 8.27485 8.78424 8.31324 8.79064 8.35164C8.79704 8.39644 8.80344 8.44125 8.80344 8.47965C8.80344 8.64605 8.73303 8.81245 8.61783 8.93405C8.49623 9.04925 8.33624 9.11965 8.16344 9.11965Z"
				fill="black"
			/>
			<path
				d="M5.92125 11.3598C5.83805 11.3598 5.75485 11.3406 5.67805 11.3086C5.60125 11.2766 5.53086 11.2318 5.46686 11.1742C5.35166 11.0526 5.28125 10.8862 5.28125 10.7198C5.28125 10.6814 5.28764 10.6366 5.29404 10.5982C5.30044 10.5534 5.31324 10.515 5.33244 10.4766C5.34524 10.4382 5.36446 10.3998 5.39006 10.3614C5.40926 10.3294 5.44126 10.2974 5.46686 10.2654C5.53086 10.2078 5.60125 10.163 5.67805 10.131C5.83165 10.067 6.01085 10.067 6.16445 10.131C6.24125 10.163 6.31164 10.2078 6.37564 10.2654C6.40124 10.2974 6.43324 10.3294 6.45244 10.3614C6.47804 10.3998 6.49726 10.4382 6.51006 10.4766C6.52926 10.515 6.54206 10.5534 6.54846 10.5982C6.55486 10.6366 6.56125 10.6814 6.56125 10.7198C6.56125 10.8862 6.49084 11.0526 6.37564 11.1742C6.31164 11.2318 6.24125 11.2766 6.16445 11.3086C6.08765 11.3406 6.00445 11.3598 5.92125 11.3598Z"
				fill="black"
			/>
			<path
				d="M2.72203 6.13773H13.602C13.8644 6.13773 14.082 5.92013 14.082 5.65773C14.082 5.39533 13.8644 5.17773 13.602 5.17773H2.72203C2.45963 5.17773 2.24203 5.39533 2.24203 5.65773C2.24203 5.92013 2.45963 6.13773 2.72203 6.13773Z"
				fill="black"
			/>
			<path
				d="M6.88188 14.3996H5.60187C3.26587 14.3996 1.92188 13.0556 1.92188 10.7196V5.27961C1.92188 2.94361 3.26587 1.59961 5.60187 1.59961H10.7219C13.0579 1.59961 14.4019 2.94361 14.4019 5.27961V7.51961C14.4019 7.78201 14.1843 7.99961 13.9219 7.99961C13.6595 7.99961 13.4419 7.78201 13.4419 7.51961V5.27961C13.4419 3.44921 12.5523 2.55961 10.7219 2.55961H5.60187C3.77148 2.55961 2.88187 3.44921 2.88187 5.27961V10.7196C2.88187 12.55 3.77148 13.4396 5.60187 13.4396H6.88188C7.14427 13.4396 7.36188 13.6572 7.36188 13.9196C7.36188 14.182 7.14427 14.3996 6.88188 14.3996Z"
				fill="black"
			/>
			<path
				d="M13.9212 9.60008C13.6588 9.60008 13.4412 9.81768 13.4412 10.0801L13.4412 12.3201C13.4412 12.7617 13.0828 13.1201 12.6412 13.1201L9.76125 13.1201C9.49885 13.1201 9.28125 13.3377 9.28125 13.6001C9.28125 13.8625 9.49885 14.0801 9.76125 14.0801L12.6412 14.0801C13.614 14.0801 14.4012 13.2929 14.4012 12.3201L14.4012 10.0801C14.4012 9.81768 14.1836 9.60008 13.9212 9.60008Z"
				fill="black"
			/>
			<path
				d="M11.3609 11.5195C11.2521 11.5195 11.1433 11.5579 11.0537 11.6283L9.13375 13.2283C9.02495 13.3179 8.96094 13.4523 8.96094 13.5995C8.96094 13.7467 9.02495 13.8747 9.13375 13.9707L11.0537 15.5707C11.2585 15.7435 11.5593 15.7115 11.7321 15.5067C11.9049 15.3019 11.8729 15.0011 11.6681 14.8283L10.1897 13.5995L11.6681 12.3707C11.8729 12.1979 11.8985 11.8971 11.7321 11.6923C11.6361 11.5771 11.4953 11.5195 11.3609 11.5195Z"
				fill="black"
			/>
		</svg>
	),
	iconGuests: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.97038 4.75634C2.97038 6.64367 4.50638 8.17968 6.39438 8.17968H6.41704C7.32838 8.17634 8.18504 7.81834 8.82638 7.17101C9.46904 6.52434 9.82171 5.66567 9.81771 4.75634C9.81771 2.86901 8.28171 1.33301 6.39438 1.33301C4.50638 1.33301 2.97038 2.86901 2.97038 4.75634ZM3.97038 4.75634C3.97038 3.42034 5.05771 2.33301 6.39438 2.33301C7.73038 2.33301 8.81771 3.42034 8.81771 4.75834C8.82038 5.40234 8.57171 6.00967 8.11704 6.46634C7.66304 6.92434 7.05771 7.17701 6.41504 7.17968H6.39438C5.05771 7.17968 3.97038 6.09234 3.97038 4.75634Z"
				fill="black"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.33301 11.679C1.33301 14.0377 5.01034 14.0377 6.39434 14.0377C7.64634 14.0377 11.4557 14.0377 11.4557 11.6657C11.4557 9.54903 8.56701 9.30436 6.39434 9.30436C5.14234 9.30436 1.33301 9.30436 1.33301 11.679ZM2.33301 11.679C2.33301 10.5424 4.54167 10.3044 6.39434 10.3044C9.08901 10.3044 10.4557 10.7624 10.4557 11.6657C10.4557 12.5757 9.08901 13.0377 6.39434 13.0377C3.69967 13.0377 2.33301 12.5804 2.33301 11.679Z"
				fill="black"
			/>
			<path
				d="M10.9881 7.42085C10.7428 7.42085 10.5288 7.24018 10.4934 6.99018C10.4554 6.71685 10.6454 6.46352 10.9188 6.42552C11.7508 6.30885 12.3788 5.58685 12.3801 4.74552C12.3801 3.90952 11.7814 3.20419 10.9581 3.06952C10.6854 3.02419 10.5008 2.76752 10.5454 2.49485C10.5901 2.22219 10.8481 2.03885 11.1194 2.08219C12.4294 2.29685 13.3801 3.41752 13.3801 4.74619C13.3774 6.08285 12.3794 7.23085 11.0581 7.41619C11.0348 7.41952 11.0114 7.42085 10.9881 7.42085Z"
				fill="black"
			/>
			<path
				d="M12.7962 11.9843C12.8715 12.1836 13.0615 12.307 13.2635 12.307C13.3228 12.307 13.3828 12.2963 13.4408 12.2743C14.4428 11.895 14.6528 11.237 14.6528 10.751C14.6528 10.0983 14.2748 9.26296 12.4708 8.99296C12.2028 8.95763 11.9435 9.14096 11.9022 9.41429C11.8615 9.68696 12.0502 9.94163 12.3235 9.98296C13.2055 10.1143 13.6528 10.373 13.6528 10.751C13.6528 10.863 13.6528 11.125 13.0862 11.3396C12.8282 11.437 12.6982 11.7263 12.7962 11.9843Z"
				fill="black"
			/>
		</svg>
	),
	minus: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5 12H19"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	plus: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M7.99967 3.33337V12.6667M3.33301 8.00004H12.6663"
				stroke={props.stroke || 'black'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	caret: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4 6L8 10L12 6"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	letter: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M1.33301 4L5.94169 6.61131C7.64074 7.574 8.35861 7.574 10.0577 6.61131L14.6663 4"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M1.34352 8.98341C1.3871 11.0271 1.40889 12.0489 2.16298 12.8059C2.91706 13.5629 3.96656 13.5892 6.06556 13.6419C7.35921 13.6745 8.64014 13.6745 9.93381 13.6419C12.0328 13.5892 13.0823 13.5629 13.8364 12.8059C14.5905 12.0489 14.6123 11.0271 14.6558 8.98341C14.6699 8.32627 14.6699 7.67307 14.6558 7.01594C14.6123 4.97225 14.5905 3.9504 13.8364 3.19345C13.0823 2.4365 12.0328 2.41013 9.93381 2.35739C8.64014 2.32488 7.35921 2.32488 6.06555 2.35738C3.96656 2.41012 2.91706 2.43648 2.16297 3.19344C1.40889 3.9504 1.3871 4.97224 1.34351 7.01594C1.3295 7.67307 1.32951 8.32627 1.34352 8.98341Z"
				stroke={props.stroke || '#1E293B'}
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	logoSmall: (props: IconProps) => (
		<svg
			width="65"
			height="33"
			viewBox="0 0 65 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M21.7025 11.6793C23.1476 12.8083 23.8701 13.3728 24.2577 14.1687C24.6452 14.9646 24.6452 15.884 24.6452 17.7229V20.4687C24.6452 24.0779 24.6452 25.8825 23.529 27.0038C22.4126 28.125 20.616 28.125 17.0229 28.125H12.6673C9.0741 28.125 7.27751 28.125 6.16125 27.0038C5.04499 25.8825 5.04499 24.0779 5.04499 20.4687V17.7229C5.04499 15.884 5.04499 14.9646 5.43253 14.1687C5.82006 13.3728 6.54259 12.8083 7.98764 11.6793L2.86719 15.2194M21.7025 11.6793C20.6703 11.0014 19.2012 9.96316 17.5673 9.53092M21.7025 11.6793L26.823 15.2194M17.5673 9.53092C16.1576 9.15799 14.7058 9.4422 13.7562 10.078C12.1228 11.1715 12.1228 12.8121 12.6673 13.359C13.7562 14.4528 15.934 13.359 17.5673 9.53092ZM17.5673 9.53092C18.9086 6.06452 17.2402 2.79495 14.8451 1.875" stroke="#E02189" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M18.1115 21.2363C17.241 21.9171 16.0973 22.3301 14.8448 22.3301C13.5924 22.3301 12.4487 21.9171 11.5781 21.2363" stroke="#E02189" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M62.6887 29.1696C62.3312 29.1696 61.9889 29.109 61.6616 28.9878C61.3344 28.8606 61.0496 28.7121 60.8072 28.5425V27.3427C61.0739 27.5366 61.3738 27.7002 61.7071 27.8335C62.0464 27.9668 62.3979 28.0335 62.7614 28.0335C63.0159 28.0335 63.225 27.9759 63.3886 27.8608C63.5583 27.7456 63.6431 27.5881 63.6431 27.3881C63.6431 27.2851 63.6068 27.1942 63.534 27.1154C63.4674 27.0306 63.3795 26.9579 63.2704 26.8973C63.1674 26.8306 63.0553 26.7761 62.9341 26.7337L61.9979 26.3701C61.6828 26.2489 61.4374 26.1035 61.2617 25.9338C61.086 25.7642 60.9618 25.5763 60.889 25.3703C60.8224 25.1582 60.7891 24.934 60.7891 24.6977C60.7891 24.322 60.889 23.9978 61.089 23.7251C61.295 23.4464 61.5617 23.2313 61.8889 23.0798C62.2221 22.9283 62.5766 22.8525 62.9523 22.8525C63.3098 22.8525 63.634 22.901 63.9249 22.998C64.2157 23.0949 64.4581 23.207 64.652 23.3343V24.5341C64.4339 24.3947 64.1915 24.2705 63.9249 24.1614C63.6643 24.0463 63.3765 23.9887 63.0614 23.9887C62.9038 23.9887 62.7524 24.016 62.6069 24.0705C62.4615 24.125 62.3403 24.2038 62.2434 24.3068C62.1525 24.4098 62.107 24.5401 62.107 24.6977C62.107 24.8976 62.1949 25.0522 62.3706 25.1612C62.5463 25.2642 62.7614 25.3703 63.0159 25.4794L63.7431 25.7884C64.1733 25.9702 64.4884 26.1853 64.6884 26.4337C64.8944 26.6761 64.9974 26.973 64.9974 27.3245C64.9974 27.6881 64.8914 28.0092 64.6793 28.288C64.4733 28.5606 64.1945 28.7758 63.8431 28.9333C63.4977 29.0908 63.1129 29.1696 62.6887 29.1696Z" fill="#E02189" />
			<path d="M55.5938 29.0615V22.9717H59.9294V24.0624H56.8572V27.9435H59.9294V29.0615H55.5938ZM56.33 26.4892V25.4258H59.5749V26.4892H56.33Z" fill="#E02189" />
			<path d="M52.702 29.1955C52.2657 29.1955 51.8537 29.1198 51.4658 28.9683C51.0841 28.8108 50.7417 28.5926 50.4388 28.3139C50.1418 28.0291 49.9085 27.6928 49.7389 27.305C49.5692 26.9111 49.4844 26.4809 49.4844 26.0143C49.4844 25.5416 49.5692 25.1114 49.7389 24.7236C49.9085 24.3358 50.1418 24.0025 50.4388 23.7238C50.7417 23.439 51.0841 23.2208 51.4658 23.0693C51.8537 22.9118 52.2657 22.833 52.702 22.833C53.0837 22.833 53.414 22.8875 53.6927 22.9966C53.9715 23.0996 54.2139 23.242 54.4199 23.4238V24.6963C54.2745 24.5812 54.123 24.4751 53.9654 24.3782C53.8079 24.2752 53.6321 24.1903 53.4382 24.1237C53.2443 24.057 53.011 24.0237 52.7384 24.0237C52.3748 24.0237 52.0445 24.1116 51.7476 24.2873C51.4507 24.457 51.2144 24.6933 51.0387 24.9963C50.8629 25.2932 50.7751 25.6325 50.7751 26.0143C50.7751 26.39 50.8629 26.7293 51.0387 27.0323C51.2144 27.3292 51.4507 27.5655 51.7476 27.7412C52.0445 27.9109 52.3748 27.9957 52.7384 27.9957C53.1443 27.9957 53.4837 27.9321 53.7564 27.8049C54.0351 27.6776 54.2866 27.5261 54.5108 27.3504V28.5775C54.3047 28.7593 54.0472 28.9077 53.7382 29.0228C53.4291 29.138 53.0837 29.1955 52.702 29.1955Z" fill="#E02189" />
			<path d="M46.2913 29.0615V22.9717H47.5547V29.0615H46.2913ZM45.2188 29.0615V27.9708H48.6272V29.0615H45.2188ZM45.2188 24.0624V22.9717H48.6272V24.0624H45.2188Z" fill="#E02189" />
			<path d="M39.375 29.0615V22.9717H41.8473C42.1321 22.9717 42.4108 23.0111 42.6835 23.0898C42.9562 23.1686 43.2016 23.2898 43.4198 23.4534C43.644 23.611 43.8197 23.814 43.9469 24.0624C44.0802 24.3108 44.1469 24.6047 44.1469 24.9441C44.1469 25.3198 44.0469 25.6379 43.847 25.8984C43.653 26.1529 43.3955 26.3469 43.0744 26.4802C42.7593 26.6074 42.4199 26.671 42.0564 26.671C41.9655 26.671 41.8473 26.6619 41.7019 26.6438C41.5625 26.6195 41.414 26.5953 41.2565 26.5711C41.0989 26.5408 40.9505 26.5135 40.8111 26.4892C40.6778 26.459 40.5748 26.4347 40.5021 26.4165V25.6439C40.6657 25.7045 40.8475 25.753 41.0474 25.7894C41.2535 25.8257 41.4595 25.8439 41.6655 25.8439C42.0291 25.8439 42.3169 25.7621 42.529 25.5985C42.7471 25.4349 42.8562 25.2167 42.8562 24.9441C42.8562 24.6471 42.7411 24.426 42.5108 24.2805C42.2866 24.1351 42.0109 24.0624 41.6837 24.0624H40.6384V29.0615H39.375ZM42.7562 29.0615L40.5021 26.4165L41.5928 26.0257L44.4196 29.0615H42.7562Z" fill="#E02189" />
			<path d="M33.5156 29.0615V22.9717H36.0334C36.3182 22.9717 36.5969 23.0232 36.8696 23.1262C37.1423 23.2292 37.3877 23.3807 37.6058 23.5807C37.83 23.7746 38.0058 24.0139 38.133 24.2987C38.2663 24.5775 38.333 24.8986 38.333 25.2622C38.333 25.7045 38.2269 26.0923 38.0148 26.4256C37.8088 26.7528 37.5331 27.0104 37.1877 27.1982C36.8423 27.38 36.4666 27.4709 36.0606 27.4709C35.7334 27.4709 35.4486 27.4406 35.2062 27.38C34.9639 27.3194 34.77 27.2437 34.6245 27.1528V26.1166C34.7578 26.1832 34.9336 26.2469 35.1517 26.3075C35.3759 26.362 35.6092 26.3893 35.8516 26.3893C36.2152 26.3893 36.503 26.2893 36.7151 26.0893C36.9332 25.8833 37.0423 25.6076 37.0423 25.2622C37.0423 25.0137 36.9847 24.8108 36.8696 24.6532C36.7605 24.4896 36.6121 24.3654 36.4242 24.2805C36.2424 24.1957 36.0425 24.1533 35.8243 24.1533H34.779V29.0615H33.5156Z" fill="#E02189" />
			<path d="M58.3359 19.7537V13.6638H59.5994V18.6175H62.5988V19.7537H58.3359Z" fill="#E02189" />
			<path d="M52.6797 19.7537V13.6638H57.0153V14.7545H53.9431V18.6357H57.0153V19.7537H52.6797ZM53.4159 17.1814V16.1179H56.6608V17.1814H53.4159Z" fill="#E02189" />
			<path d="M48.5755 19.7539V13.6641H49.8389V19.7539H48.5755ZM46.7031 14.7548V13.6641H51.7113V14.7548H46.7031Z" fill="#E02189" />
			<path d="M43.1825 19.8889C42.7463 19.8889 42.3342 19.8132 41.9464 19.6617C41.5646 19.5041 41.2253 19.286 40.9284 19.0072C40.6375 18.7224 40.4073 18.3861 40.2376 17.9983C40.074 17.6044 39.9922 17.1742 39.9922 16.7076C39.9922 16.235 40.074 15.8048 40.2376 15.4169C40.4073 15.0291 40.6375 14.6959 40.9284 14.4171C41.2253 14.1323 41.5646 13.9142 41.9464 13.7627C42.3342 13.6051 42.7463 13.5264 43.1825 13.5264C43.6188 13.5264 44.0279 13.6051 44.4096 13.7627C44.7914 13.9142 45.1277 14.1323 45.4185 14.4171C45.7154 14.6959 45.9457 15.0291 46.1093 15.4169C46.279 15.8048 46.3638 16.235 46.3638 16.7076C46.3638 17.1742 46.279 17.6044 46.1093 17.9983C45.9457 18.3861 45.7154 18.7224 45.4185 19.0072C45.1277 19.286 44.7914 19.5041 44.4096 19.6617C44.0279 19.8132 43.6188 19.8889 43.1825 19.8889ZM43.1825 18.6891C43.5461 18.6891 43.8703 18.6043 44.1551 18.4346C44.4399 18.2589 44.6641 18.0226 44.8277 17.7256C44.9913 17.4287 45.0731 17.0894 45.0731 16.7076C45.0731 16.3259 44.9913 15.9865 44.8277 15.6896C44.6641 15.3866 44.4399 15.1503 44.1551 14.9807C43.8703 14.8049 43.5461 14.7171 43.1825 14.7171C42.819 14.7171 42.4948 14.8049 42.21 14.9807C41.9252 15.1503 41.698 15.3866 41.5283 15.6896C41.3647 15.9926 41.2829 16.3319 41.2829 16.7076C41.2829 17.0833 41.3647 17.4227 41.5283 17.7256C41.6919 18.0226 41.9161 18.2589 42.2009 18.4346C42.4918 18.6043 42.819 18.6891 43.1825 18.6891Z" fill="#E02189" />
			<path d="M37.6527 19.7537V13.6638H38.907V19.7537H37.6527ZM33.5625 19.7537V13.6638H34.8259V19.7537H33.5625ZM34.6714 17.2814V16.1452H37.9072V17.2814H34.6714Z" fill="#E02189" />
			<path d="M45.8438 10.4451V4.35522H48.3615C48.6463 4.35522 48.925 4.40673 49.1977 4.50974C49.4704 4.61276 49.7158 4.76424 49.9339 4.96421C50.1582 5.15812 50.3339 5.39747 50.4611 5.68227C50.5944 5.96101 50.6611 6.28216 50.6611 6.64574C50.6611 7.08808 50.5551 7.47589 50.343 7.80917C50.1369 8.13639 49.8612 8.39392 49.5158 8.58176C49.1704 8.76355 48.7948 8.85444 48.3888 8.85444C48.0615 8.85444 47.7767 8.82414 47.5344 8.76355C47.292 8.70295 47.0981 8.62721 46.9526 8.53632V7.50013C47.086 7.56679 47.2617 7.63041 47.4798 7.69101C47.704 7.74554 47.9373 7.77281 48.1797 7.77281C48.5433 7.77281 48.8311 7.67283 49.0432 7.47286C49.2613 7.26684 49.3704 6.99113 49.3704 6.64574C49.3704 6.39729 49.3128 6.1943 49.1977 6.03675C49.0886 5.87314 48.9402 5.74892 48.7523 5.66409C48.5705 5.57925 48.3706 5.53684 48.1524 5.53684H47.1072V10.4451H45.8438Z" fill="#E02189" />
			<path d="M41.62 10.5813C41.1838 10.5813 40.7717 10.5055 40.3839 10.354C40.0021 10.1965 39.6628 9.97835 39.3659 9.69962C39.075 9.41482 38.8448 9.07851 38.6751 8.6907C38.5115 8.29683 38.4297 7.8666 38.4297 7.40002C38.4297 6.92737 38.5115 6.49714 38.6751 6.10933C38.8448 5.72152 39.075 5.38824 39.3659 5.1095C39.6628 4.82471 40.0021 4.60656 40.3839 4.45507C40.7717 4.29752 41.1838 4.21875 41.62 4.21875C42.0563 4.21875 42.4654 4.29752 42.8471 4.45507C43.2289 4.60656 43.5652 4.82471 43.856 5.1095C44.1529 5.38824 44.3832 5.72152 44.5468 6.10933C44.7165 6.49714 44.8013 6.92737 44.8013 7.40002C44.8013 7.8666 44.7165 8.29683 44.5468 8.6907C44.3832 9.07851 44.1529 9.41482 43.856 9.69962C43.5652 9.97835 43.2289 10.1965 42.8471 10.354C42.4654 10.5055 42.0563 10.5813 41.62 10.5813ZM41.62 9.38149C41.9836 9.38149 42.3078 9.29666 42.5926 9.12699C42.8774 8.95126 43.1016 8.71494 43.2652 8.41802C43.4288 8.1211 43.5106 7.78177 43.5106 7.40002C43.5106 7.01826 43.4288 6.67893 43.2652 6.38201C43.1016 6.07903 42.8774 5.84271 42.5926 5.67304C42.3078 5.49732 41.9836 5.40945 41.62 5.40945C41.2565 5.40945 40.9323 5.49732 40.6475 5.67304C40.3627 5.84271 40.1355 6.07903 39.9658 6.38201C39.8022 6.68499 39.7204 7.02432 39.7204 7.40002C39.7204 7.77571 39.8022 8.11504 39.9658 8.41802C40.1294 8.71494 40.3536 8.95126 40.6384 9.12699C40.9293 9.29666 41.2565 9.38149 41.62 9.38149Z" fill="#E02189" />
			<path d="M34.8724 10.4451V4.35522H36.1358V10.4451H34.8724ZM33 5.44594V4.35522H38.0082V5.44594H33Z" fill="#E02189" />
		</svg>
	),
	globeBig: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="#475569"
				strokeWidth="1.5"
			/>
			<path
				d="M8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2C12 2 8 6 8 12Z"
				stroke="#475569"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M21 12H3"
				stroke="#475569"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	chevron: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9 18L15 12L9 6"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	chevronSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 12L10 8L6 4"
				stroke={props.stroke || 'black'}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	lensSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
				stroke="#1E293B"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	star: (props: IconProps) => (
		<svg
			width="14"
			height="13"
			viewBox="0 0 14 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.28671 1.19529C6.51122 0.504303 7.48878 0.504305 7.71329 1.19529L8.62773 4.00963C8.72813 4.31864 9.0161 4.52786 9.34102 4.52786H12.3002C13.0267 4.52786 13.3288 5.45758 12.741 5.88463L10.347 7.62398C10.0841 7.81497 9.97415 8.15349 10.0746 8.46251L10.989 11.2768C11.2135 11.9678 10.4226 12.5424 9.83486 12.1154L7.44084 10.376C7.17797 10.185 6.82203 10.185 6.55916 10.376L4.16514 12.1154C3.57735 12.5424 2.7865 11.9678 3.01101 11.2768L3.92544 8.46251C4.02585 8.15349 3.91586 7.81497 3.65299 7.62398L1.25897 5.88463C0.671185 5.45757 0.973268 4.52786 1.69981 4.52786H4.65898C4.9839 4.52786 5.27187 4.31864 5.37227 4.00963L6.28671 1.19529Z"
				fill={props.fill || '#003E74'}
			/>
		</svg>
	),
	filters: (props: IconProps) => (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H28C32.1421 0.5 35.5 3.85786 35.5 8V28C35.5 32.1421 32.1421 35.5 28 35.5H8C3.85786 35.5 0.5 32.1421 0.5 28V8Z"
				stroke="#E2E8F0"
			/>
			<path
				d="M26.5 13H24"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M26.5 23H21.5"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 23H9.5"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5 13H9.5"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 10H23C23.5523 10 24 10.4477 24 11V15C24 15.5523 23.5523 16 23 16H19C18.4477 16 18 15.5523 18 15V11C18 10.4477 18.4477 10 19 10Z"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M13 20H17C17.5523 20 18 20.4477 18 21V25C18 25.5523 17.5523 26 17 26H13C12.4477 26 12 25.5523 12 25V21C12 20.4477 12.4477 20 13 20Z"
				stroke="#E02189"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	filtersSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.668 4.66602H12.0013"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.668 11.334H10.3346"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4 11.334H2.33333"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.66797 4.66602H2.33464"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.66667 2.66602H11.3333C11.7015 2.66602 12 2.9645 12 3.33268V5.99935C12 6.36754 11.7015 6.66602 11.3333 6.66602H8.66667C8.29847 6.66602 8 6.36754 8 5.99935V3.33268C8 2.9645 8.29847 2.66602 8.66667 2.66602Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M4.66667 9.33398H7.33333C7.70153 9.33398 8 9.63245 8 10.0007V12.6673C8 13.0355 7.70153 13.334 7.33333 13.334H4.66667C4.29847 13.334 4 13.0355 4 12.6673V10.0007C4 9.63245 4.29847 9.33398 4.66667 9.33398Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	logoSmaller: (props: IconProps) => (
		<svg
			width="28"
			height="30"
			viewBox="0 0 21 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M20.7025 11.6793C22.1476 12.8083 22.8701 13.3728 23.2577 14.1687C23.6452 14.9646 23.6452 15.884 23.6452 17.7229V20.4687C23.6452 24.0779 23.6452 25.8825 22.529 27.0038C21.4126 28.125 19.616 28.125 16.0229 28.125H11.6673C8.0741 28.125 6.27751 28.125 5.16125 27.0038C4.04499 25.8825 4.04499 24.0779 4.04499 20.4687V17.7229C4.04499 15.884 4.04499 14.9646 4.43253 14.1687C4.82006 13.3728 5.54259 12.8083 6.98764 11.6793L1.86719 15.2194M20.7025 11.6793C19.6703 11.0014 18.2012 9.96316 16.5673 9.53092M20.7025 11.6793L25.823 15.2194M16.5673 9.53092C15.1576 9.15799 13.7058 9.4422 12.7562 10.078C11.1228 11.1715 11.1228 12.8121 11.6673 13.359C12.7562 14.4528 14.934 13.359 16.5673 9.53092ZM16.5673 9.53092C17.9086 6.06452 16.2402 2.79495 13.8451 1.875" stroke="#E02189" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M17.1115 21.2363C16.241 21.9171 15.0973 22.3301 13.8448 22.3301C12.5924 22.3301 11.4487 21.9171 10.5781 21.2363" stroke="#E02189" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	),
	trashCan: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13 3.66602L12.5869 10.3494C12.4813 12.0569 12.4285 12.9107 12.0005 13.5246C11.7889 13.8281 11.5165 14.0842 11.2005 14.2767C10.5614 14.666 9.706 14.666 7.99513 14.666C6.28208 14.666 5.42553 14.666 4.78603 14.2759C4.46987 14.0831 4.19733 13.8265 3.98579 13.5225C3.55792 12.9077 3.5063 12.0527 3.40307 10.3428L3 3.66602"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2 3.66732H14M10.7038 3.66732L10.2487 2.72847C9.9464 2.10482 9.7952 1.793 9.53447 1.59852C9.47667 1.55538 9.4154 1.51701 9.35133 1.48378C9.0626 1.33398 8.71607 1.33398 8.023 1.33398C7.31253 1.33398 6.95733 1.33398 6.66379 1.49006C6.59873 1.52466 6.53665 1.56458 6.47819 1.60943C6.21443 1.81178 6.06709 2.13502 5.77241 2.78149L5.36861 3.66732"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M6.33301 11V7"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M9.66699 11V7"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconAlert: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M12 8.5V12.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 16H12.009"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconAlertSmall: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.00732 5.33219V7.99886M8.00732 10.6655H8.00066M14.6668 7.9987C14.6668 11.6806 11.6821 14.6654 8.00016 14.6654C4.31826 14.6654 1.3335 11.6806 1.3335 7.9987C1.3335 4.3168 4.31826 1.33203 8.00016 1.33203C11.6821 1.33203 14.6668 4.3168 14.6668 7.9987Z"
				stroke="#64748B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconArrow: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M17.5 6.5L6 18"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 6H18V16"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	plane: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.8667 3.7804C16.7931 3.03188 17.8307 2.98644 18.9644 3.00233C19.5508 3.01055 19.844 3.01467 20.0792 3.10588C20.4524 3.2506 20.7494 3.54764 20.8941 3.92081C20.9853 4.15601 20.9894 4.4492 20.9977 5.03557C21.0136 6.16926 20.9681 7.20686 20.2196 8.13326C19.5893 8.91337 18.5059 9.32101 17.9846 10.1821C17.5866 10.8395 17.772 11.5203 17.943 12.2209L19.2228 17.4662C19.4779 18.5115 19.2838 19.1815 18.5529 19.9124C18.164 20.3013 17.8405 20.2816 17.5251 19.779L13.6627 13.6249L11.8181 15.0911C11.1493 15.6228 10.8149 15.8886 10.6392 16.2627C10.2276 17.1388 10.4889 18.4547 10.5022 19.4046C10.5096 19.9296 10.0559 20.9644 9.41391 20.9993C9.01756 21.0209 8.88283 20.5468 8.75481 20.2558L7.52234 17.4544C7.2276 16.7845 7.21552 16.7724 6.54556 16.4777L3.74415 15.2452C3.45318 15.1172 2.97914 14.9824 3.00071 14.5861C3.03565 13.9441 4.07036 13.4904 4.59536 13.4978C5.54532 13.5111 6.86122 13.7724 7.73734 13.3608C8.11142 13.1851 8.37724 12.8507 8.90888 12.1819L10.3751 10.3373L4.22103 6.47489C3.71845 6.15946 3.69872 5.83597 4.08755 5.44715C4.8185 4.7162 5.48851 4.52214 6.53377 4.77718L11.7791 6.05703C12.4797 6.22798 13.1605 6.41343 13.8179 6.0154C14.679 5.49411 15.0866 4.41074 15.8667 3.7804Z"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	bed: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22 17H2"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 21V14C22 12.8954 21.1046 12 20 12H4C2.89543 12 2 12.8954 2 14V21"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 12V10.309C16 10.1196 15.8935 9.94708 15.7199 9.87128C15.1014 9.60118 13.5507 9 12 9C10.4493 9 8.89856 9.60118 8.28011 9.87128C8.10655 9.94708 8 10.1196 8 10.309V12"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 12V6.46798C20 6.17143 19.8696 5.88847 19.6357 5.70611C17.4413 3.99491 14.8181 3 12 3C9.18187 3 6.5587 3.99491 4.36426 5.70611C4.1304 5.88846 4 6.17143 4 6.46798V12"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	town: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13 2L2 7"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 3V22H7C5.11438 22 4.17157 22 3.58579 21.4142C3 20.8284 3 19.8856 3 18V7"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 7L22 12"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 21.9997H17C18.8856 21.9997 19.8284 21.9997 20.4142 21.4139C21 20.8281 21 19.8853 21 17.9997V11.5"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 10V7"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 11H8M7 15H8"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 14H17"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5 22V18"
				stroke="black"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconArrowSmall: (props: IconProps) => (
		<svg
			width="17"
			height="16"
			viewBox="0 0 17 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.1667 4.33203L4.5 11.9987"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.8335 4H12.5002V10.6667"
				stroke="white"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconTopRating: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 6L9.33333 6.00008"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 10H6.66667"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 2H12.6667"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.3332 14V6M12.3332 14C11.8664 14 10.9942 12.6705 10.6665 12.3333M12.3332 14C12.8 14 13.6722 12.6705 13.9998 12.3333"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconPriceUp: (props: IconProps) => (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.3337 2V10M12.3337 2C11.8669 2 10.9947 3.32953 10.667 3.66667M12.3337 2C12.8005 2 13.6727 3.32953 14.0003 3.66667"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.75 7.08512C7.75 5.74872 6.51878 4.66536 5 4.66536M5 4.66536C3.48121 4.66536 2.25 5.74872 2.25 7.08512C2.25 8.4215 3 9.15916 5 9.15916C7 9.15916 8 9.85056 8 11.579C8 13.3074 6.65685 13.9987 5 13.9987M5 4.66536V3.33203M5 13.9987C3.34315 13.9987 2 12.9154 2 11.579M5 13.9987V15.332"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconPriceDown: (props: IconProps) => (
		<svg
			width="16"
			height="17"
			viewBox="0 0 16 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12.3337 15V7M12.3337 15C11.8669 15 10.9947 13.6705 10.667 13.3333M12.3337 15C12.8005 15 13.6727 13.6705 14.0003 13.3333"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.75 5.42106C7.75 4.08466 6.51878 3.0013 5 3.0013M5 3.0013C3.48121 3.0013 2.25 4.08466 2.25 5.42106C2.25 6.75744 3 7.4951 5 7.4951C7 7.4951 8 8.1865 8 9.9149C8 11.6433 6.65685 12.3346 5 12.3346M5 3.0013V1.66797M5 12.3346C3.34315 12.3346 2 11.2513 2 9.9149M5 12.3346V13.668"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconShield: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.99935 7.66666L7.33268 9L10.3327 6M13.3327 8C13.3327 11.2723 9.76338 13.6523 8.46468 14.4099C8.31708 14.496 8.24328 14.5391 8.13914 14.5614C8.05831 14.5787 7.94039 14.5787 7.85956 14.5614C7.75541 14.5391 7.68162 14.496 7.53402 14.4099C6.23532 13.6523 2.66602 11.2723 2.66602 8V4.81173C2.66602 4.27872 2.66602 4.01222 2.75319 3.78313C2.8302 3.58076 2.95534 3.40018 3.11779 3.25702C3.30168 3.09495 3.55121 3.00138 4.05029 2.81423L7.62482 1.47378C7.76341 1.4218 7.83271 1.39582 7.904 1.38552C7.96724 1.37638 8.03146 1.37638 8.09469 1.38552C8.16598 1.39582 8.23528 1.4218 8.37388 1.47378L11.9484 2.81423C12.4475 3.00138 12.697 3.09495 12.8809 3.25702C13.0434 3.40018 13.1685 3.58076 13.2455 3.78313C13.3327 4.01222 13.3327 4.27872 13.3327 4.81173V8Z"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconNoMoney: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M14.6673 9.00004V5.46671C14.6673 4.71997 14.6673 4.3466 14.522 4.06139C14.3942 3.8105 14.1902 3.60653 13.9393 3.4787C13.6541 3.33337 13.2807 3.33337 12.534 3.33337L3.46732 3.33337C2.72058 3.33337 2.34721 3.33337 2.062 3.4787C1.81111 3.60653 1.60714 3.8105 1.47931 4.06139C1.33398 4.3466 1.33398 4.71997 1.33398 5.46671L1.33398 10.5334C1.33398 11.2801 1.33398 11.6535 1.47931 11.9387C1.60714 12.1896 1.81111 12.3935 2.062 12.5214C2.34721 12.6667 2.72058 12.6667 3.46732 12.6667H9.66732M4.00065 7.00004V9.00004M12.0007 7.00004V9.00004M11.4793 11L13.0007 12.5214M13.0007 12.5214L14.522 14.0427M13.0007 12.5214L14.522 11M13.0007 12.5214L11.4793 14.0427M9.66732 8.00004C9.66732 8.92051 8.92113 9.66671 8.00065 9.66671C7.08018 9.66671 6.33398 8.92051 6.33398 8.00004C6.33398 7.07957 7.08018 6.33337 8.00065 6.33337C8.92113 6.33337 9.66732 7.07957 9.66732 8.00004Z"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCheckin: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9 17.625C9.0736 19.4769 10.6169 21.0494 12.6844 20.9988C13.1654 20.9871 13.7599 20.8194 14.9489 20.484C17.8104 19.6769 20.2944 18.3204 20.8904 15.2816C21 14.723 21 14.0944 21 12.8373V11.1627C21 9.90564 21 9.27707 20.8904 8.71848C20.2944 5.67966 17.8104 4.32317 14.9489 3.51603C13.7599 3.18065 13.1654 3.01296 12.6844 3.00119C10.6169 2.95061 9.0736 4.52308 9 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M14 12H3M14 12C14 11.2998 12.0057 9.99153 11.5 9.5M14 12C14 12.7002 12.0057 14.0085 11.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconCheckout: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15 17.625C14.9264 19.4769 13.3831 21.0494 11.3156 20.9988C10.8346 20.9871 10.2401 20.8194 9.05112 20.484C6.18961 19.6769 3.70555 18.3204 3.10956 15.2816C3 14.723 3 14.0944 3 12.8373V11.1627C3 9.90564 3 9.27707 3.10956 8.71848C3.70555 5.67966 6.18961 4.32317 9.05112 3.51603C10.2401 3.18065 10.8346 3.01296 11.3156 3.00119C13.3831 2.95061 14.9264 4.52308 15 6.37502"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M21 12H10M21 12C21 11.2998 19.0057 9.99153 18.5 9.5M21 12C21 12.7002 19.0057 14.0085 18.5 14.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconImagePlaceholder: (props: IconProps) => (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M3.33398 16.0007C3.33398 10.0295 3.33398 7.04397 5.18897 5.18897C7.04397 3.33398 10.0295 3.33398 16.0007 3.33398C21.9717 3.33398 24.9573 3.33398 26.8124 5.18897C28.6673 7.04397 28.6673 10.0295 28.6673 16.0007C28.6673 21.9717 28.6673 24.9573 26.8124 26.8124C24.9573 28.6673 21.9717 28.6673 16.0007 28.6673C10.0295 28.6673 7.04397 28.6673 5.18897 26.8124C3.33398 24.9573 3.33398 21.9717 3.33398 16.0007Z"
				stroke="white"
				strokeWidth="1.5"
			/>
			<path
				d="M22 12C23.1046 12 24 11.1046 24 10C24 8.89543 23.1046 8 22 8C20.8954 8 20 8.89543 20 10C20 11.1046 20.8954 12 22 12Z"
				stroke="white"
				strokeWidth="1.5"
			/>
			<path
				d="M21.3333 29.3327C20.5073 26.3659 18.5793 23.7088 15.8353 21.7783C12.8768 19.6965 9.16217 18.5948 5.35425 18.6696C4.90211 18.6685 4.45035 18.6829 4 18.7128"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M17.334 24.0006C19.6027 22.2317 22.0467 21.3243 24.5156 21.3341C25.9156 21.3326 27.3089 21.6294 28.6673 22.2162"
				stroke="white"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),

	wifi: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 18.5H12.0118"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M8.25 15.5C10.25 13.5 13.75 13.5 15.75 15.5"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M18.5 12.5C14.7324 9.16667 9.5 9.16667 5.5 12.5"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2 9.5C8.31579 4.16669 15.6842 4.16668 22 9.49989"
				stroke="#1D1D1D"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	pool: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22 21H21C19.5486 21 18.278 20.1411 18 19C17.722 20.1411 16.4514 21 15 21C13.5486 21 12.278 20.1411 12 19C11.722 20.1411 10.4514 21 9 21C7.54863 21 6.27796 20.1411 6 19C5.72204 20.1411 4.45137 21 3 21H2"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 3L18.7351 3.0883C17.4151 3.52832 16.755 3.74832 16.3775 4.2721C16 4.79587 16 5.49159 16 6.88304V17"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11 3L10.7351 3.0883C9.41505 3.52832 8.75503 3.74832 8.37752 4.2721C8 4.79587 8 5.49159 8 6.88304V17"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8 7H16M8 11H16M8 15H16"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	parking: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				stroke="#141B34"
				strokeWidth="1.5"
			/>
			<path
				d="M9 13V8.4C9 8.02774 9 7.84162 9.04894 7.69098C9.14786 7.38655 9.38655 7.14786 9.69098 7.04894C9.84162 7 10.0277 7 10.4 7H13C14.6569 7 16 8.34315 16 10C16 11.6569 14.6569 13 13 13H9ZM9 13V18"
				stroke="#141B34"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	twentyFourHours: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.04798 8.60657L2.53784 8.45376C4.33712 3.70477 9.503 0.999917 14.5396 2.34474C19.904 3.77711 23.0904 9.26107 21.6565 14.5935C20.2227 19.926 14.7116 23.0876 9.3472 21.6553C5.36419 20.5917 2.58192 17.2946 2 13.4844"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7 10.8C7 9.80589 7.86342 9 8.92857 9C9.99372 9 10.8571 9.80589 10.8571 10.8C10.8571 12.0472 9.00546 13.1503 7.86805 13.7103C7.35155 13.9646 7 14.455 7 15H10.8571M17 9V12.3M17 12.3V15M17 12.3H13.4231C13.2683 12.3 13.1429 12.1829 13.1429 12.0384C13.1429 12.013 13.1468 11.9876 13.1547 11.9632L14.1071 9"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	family: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M15.5 11C15.5 9.067 13.933 7.5 12 7.5C10.067 7.5 8.5 9.067 8.5 11C8.5 12.933 10.067 14.5 12 14.5C13.933 14.5 15.5 12.933 15.5 11Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15.483 11.3499C15.805 11.4475 16.1465 11.5 16.5003 11.5C18.4333 11.5 20.0003 9.933 20.0003 8C20.0003 6.067 18.4333 4.5 16.5003 4.5C14.6854 4.5 13.1931 5.8814 13.0176 7.65013"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.9827 7.65013C10.8072 5.8814 9.31492 4.5 7.5 4.5C5.567 4.5 4 6.067 4 8C4 9.933 5.567 11.5 7.5 11.5C7.85381 11.5 8.19535 11.4475 8.51727 11.3499"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M22 16.5C22 13.7386 19.5376 11.5 16.5 11.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M17.5 19.5C17.5 16.7386 15.0376 14.5 12 14.5C8.96243 14.5 6.5 16.7386 6.5 19.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.5 11.5C4.46243 11.5 2 13.7386 2 16.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	beach: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 15.7501C2 15.7501 3.79534 15 7 15C12 15 16 18 22 18"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 21H22"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.594 3.22761C9.74838 4.04368 7.89871 6.85224 8.0043 9.87504C8.02623 10.5029 8.03719 10.8168 8.30546 10.9556C8.57373 11.0944 8.85218 10.8977 9.40908 10.5041L10.6506 9.6268C10.8371 9.49503 11.0585 9.43155 11.2815 9.44587L14.1977 9.63321L16.6357 7.91042C16.8222 7.77865 17.0435 7.71517 17.2666 7.7295L18.7879 7.82723C19.4407 7.86916 19.7671 7.89013 19.9291 7.63883C20.0912 7.38753 19.9594 7.11583 19.6959 6.57242C18.3856 3.86989 15.4553 2.40707 12.594 3.22761Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.5 9.5L16.5 17M12.2857 3L12 2"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	cocktail: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.20538 15.3582L4.51713 11.0812C2.62475 8.88671 1.67856 7.78948 2.09833 6.89474C2.5181 6 3.97907 6 6.90099 6H11.099C14.0209 6 15.4819 6 15.9017 6.89474C16.3214 7.78948 15.3753 8.88671 13.4829 11.0812L9.79462 15.3582C9.42563 15.7861 9.24114 16 9 16C8.75886 16 8.57437 15.7861 8.20538 15.3582Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M8.5 6L8.09898 3.59389C8.03809 3.22852 7.78022 2.92674 7.42882 2.80961L5 2"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M9 16V22M6 22H12"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M15.8601 8.83333C16.5043 9.54937 17.4403 10 18.4822 10C20.425 10 22 8.433 22 6.5C22 4.567 20.425 3 18.4822 3C16.71 3 15.2438 4.30385 15 6"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	pets: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21.4565 7.97344C21.2899 7.90795 21.1124 7.87455 20.9334 7.875H20.9146C19.9691 7.88906 18.9088 8.77453 18.3524 10.1138C17.6854 11.7159 17.9924 13.3552 19.0434 13.7766C19.2098 13.8421 19.3871 13.8755 19.566 13.875C20.5162 13.875 21.591 12.9844 22.1521 11.6363C22.8144 10.0341 22.5027 8.39484 21.4565 7.97344ZM15.3562 14.2256C14.053 12.0633 13.4905 11.25 11.9999 11.25C10.5093 11.25 9.9421 12.0684 8.63898 14.2256C7.52335 16.0706 5.26866 16.2244 4.70616 17.7914C4.59204 18.0784 4.53473 18.3849 4.53741 18.6937C4.53741 19.9683 5.51241 21 6.71241 21C8.20304 21 10.2327 19.8098 12.0046 19.8098C13.7765 19.8098 15.7968 21 17.2874 21C18.4874 21 19.4577 19.9687 19.4577 18.6937C19.4588 18.3846 19.3999 18.0781 19.2843 17.7914C18.7218 16.2187 16.4718 16.0706 15.3562 14.2256ZM9.02382 9.1875C9.08659 9.18756 9.14927 9.18286 9.21132 9.17344C10.2993 9.01547 10.9785 7.50797 10.7319 5.80547C10.4999 4.20047 9.52585 3 8.50726 3C8.44449 2.99994 8.38181 3.00465 8.31976 3.01406C7.23179 3.17203 6.55257 4.67953 6.79913 6.38203C7.03116 7.98234 8.00523 9.1875 9.02382 9.1875ZM17.1993 6.38203C17.4459 4.67953 16.7666 3.17203 15.6787 3.01406C15.6166 3.00465 15.5539 2.99994 15.4912 3C14.4726 3 13.5004 4.20047 13.2679 5.80547C13.0213 7.50797 13.7005 9.01547 14.7885 9.17344C14.8506 9.18286 14.9132 9.18756 14.976 9.1875C15.9946 9.1875 16.9687 7.98234 17.1993 6.38203ZM4.95788 13.7766C6.00741 13.3547 6.31398 11.7141 5.64788 10.1138C5.08726 8.76563 4.01335 7.875 3.0646 7.875C2.88573 7.8745 2.70838 7.9079 2.54195 7.97344C1.49241 8.39531 1.18585 10.0359 1.85195 11.6363C2.41257 12.9844 3.48648 13.875 4.43523 13.875C4.6141 13.8755 4.79145 13.8421 4.95788 13.7766Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	),
	spa: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4 14.0695C5.0145 14.0695 6.43122 13.7685 7.31944 14.4193L9.08188 15.7108C9.73667 16.1906 10.4458 16.0325 11.1765 15.9178C12.1389 15.7667 13 16.5875 13 17.6562C13 17.9482 10.9272 18.6905 10.6276 18.8316C10.0391 19.1088 9.36297 19.0406 8.83021 18.6502L6.84211 17.1934"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13 17L17.091 15.1096C17.8244 14.854 18.6331 15.0535 19.1797 15.625L19.8505 16.3262C20.0902 16.5768 20.0338 16.9976 19.7375 17.1697L11.8829 21.7315C11.4097 22.0063 10.8514 22.0734 10.3309 21.9179L4 20.0269"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.002 12C12.002 12 14.102 9.76142 14.102 7C14.102 4.23858 12.002 2 12.002 2C12.002 2 9.90195 4.23858 9.90195 7C9.90195 9.76142 12.002 12 12.002 12ZM12.002 12C12.002 12 15.069 11.9316 17.002 9.95918C18.935 7.98674 19.002 4.85714 19.002 4.85714C19.002 4.85714 17.7325 4.88544 16.3123 5.43087M12.002 12C12.002 12 8.93495 11.9316 7.00195 9.95918C5.06895 7.98674 5.00195 4.85714 5.00195 4.85714C5.00195 4.85714 6.2714 4.88544 7.69162 5.43087"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	airConditioner: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 5.94145C5.5 9.37313 10.5755 7.90241 11.7324 5.94145C11.9026 5.65301 12 5.31814 12 4.96096C12 3.87795 11.1046 3 10 3C8.89543 3 8 3.87795 8 4.96096"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M17 8.92814C17 7.31097 18.1193 6 19.5 6C20.8807 6 22 7.31097 22 8.92814C22 9.6452 21.7799 10.3021 21.4146 10.8111C19.3463 14.1915 9.2764 12.9164 4 11.8563"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M13.0854 19.8873C13.2913 20.5356 13.8469 21 14.5 21C15.3284 21 16 20.2528 16 19.331C16 19.0176 15.9224 18.7244 15.7873 18.4738C14.4999 15.9925 7.99996 14.3239 2 18.7746"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19 15.5H21"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	houseKeeping: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M21 3L13 11.5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.44573 11.0854C6.96539 12.0368 4.98269 11.8736 3 11.0885C3.50059 17.531 6.50414 20.0089 10.5089 21C10.5089 21 13.5261 18.8664 13.961 13.8074C14.0081 13.2595 14.0317 12.9856 13.9178 12.6769C13.8038 12.3682 13.5802 12.1468 13.1329 11.704C12.3973 10.9757 12.0295 10.6116 11.5929 10.5204C11.1564 10.4293 10.5862 10.648 9.44573 11.0854Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M4.5 16.4464C4.5 16.4464 7 16.9286 9.5 15"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M8.5 7.25C8.5 7.94036 7.94036 8.5 7.25 8.5C6.55964 8.5 6 7.94036 6 7.25C6 6.55964 6.55964 6 7.25 6C7.94036 6 8.5 6.55964 8.5 7.25Z"
				stroke="#1E293B"
				strokeWidth="1.5"
			/>
			<path
				d="M11 4V4.1"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	sofa: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 17V20M18 17V20"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 9C20 7.13077 20 6.19615 19.5981 5.5C19.3348 5.04394 18.9561 4.66523 18.5 4.40192C17.8038 4 16.8692 4 15 4H9C7.13077 4 6.19615 4 5.5 4.40192C5.04394 4.66523 4.66523 5.04394 4.40192 5.5C4 6.19615 4 7.13077 4 9"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 9C18.8954 9 18 9.89543 18 11V13C18 13.8273 17.8273 14 17 14H7C6.17267 14 6 13.8273 6 13V11C6 9.89543 5.10457 9 4 9C2.89543 9 2 9.89543 2 11C2 11.7403 2.4022 12.3866 3 12.7324V13C3 14.8856 3 15.8284 3.58579 16.4142C4.17157 17 5.11438 17 7 17H17C18.8856 17 19.8284 17 20.4142 16.4142C21 15.8284 21 14.8856 21 13V12.7324C21.5978 12.3866 22 11.7403 22 11C22 9.89543 21.1046 9 20 9Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</svg>
	),
	kitchen: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 5H10"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M18 5.00895V5"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 8H21"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M2 22H22"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M3 22V5C3 2.518 3.518 2 6 2H18C20.482 2 21 2.518 21 5V22"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 17V13C6 12.0572 6 11.5858 6.29289 11.2929C6.58579 11 7.05719 11 8 11H16C16.9428 11 17.4142 11 17.7071 11.2929C18 11.5858 18 12.0572 18 13V17C18 17.9428 18 18.4142 17.7071 18.7071C17.4142 19 16.9428 19 16 19H8C7.05719 19 6.58579 19 6.29289 18.7071C6 18.4142 6 17.9428 6 17Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	microwave: (props: IconProps) => (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M2 15V7C2 5.11438 2 4.17157 2.58579 3.58579C3.17157 3 4.11438 3 6 3H18C19.8856 3 20.8284 3 21.4142 3.58579C22 4.17157 22 5.11438 22 7V15C22 16.8856 22 17.8284 21.4142 18.4142C20.8284 19 19.8856 19 18 19H6C4.11438 19 3.17157 19 2.58579 18.4142C2 17.8284 2 16.8856 2 15Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M19 6.00895V6M19 9.00447V8.99553M19 12V11.9911"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 14V8C5 7.05719 5 6.58579 5.29289 6.29289C5.58579 6 6.05719 6 7 6H14C14.9428 6 15.4142 6 15.7071 6.29289C16 6.58579 16 7.05719 16 8V14C16 14.9428 16 15.4142 15.7071 15.7071C15.4142 16 14.9428 16 14 16H7C6.05719 16 5.58579 16 5.29289 15.7071C5 15.4142 5 14.9428 5 14Z"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M5 19V21M19 19V21"
				stroke="#1E293B"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	),
	iconAngle: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M11.6667 4.33337L4 12"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.33325 4H11.9999V10.6667"
				stroke="#003E74"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
	iconEdit: (props: IconProps) => (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_55973_5048)">
				<path
					d="M9.38312 2.59034C9.87992 2.05209 10.1283 1.78297 10.3923 1.62599C11.0291 1.24721 11.8134 1.23543 12.4609 1.59492C12.7293 1.74391 12.9853 2.00545 13.4973 2.52855C14.0094 3.05164 14.2655 3.31319 14.4113 3.58733C14.7632 4.24879 14.7517 5.0499 14.3809 5.70051C14.2272 5.97015 13.9637 6.22389 13.4369 6.73137L7.16772 12.7696C6.16924 13.7313 5.66999 14.2122 5.04603 14.4558C4.42207 14.6996 3.73612 14.6816 2.36423 14.6458L2.17757 14.6409C1.75993 14.63 1.5511 14.6245 1.42971 14.4867C1.30832 14.349 1.32489 14.1362 1.35804 13.7108L1.37604 13.4798C1.46933 12.2824 1.51597 11.6837 1.74979 11.1455C1.98361 10.6073 2.38695 10.1704 3.19361 9.29637L9.38312 2.59034Z"
					stroke="#64748B"
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path
					d="M8.66602 2.66663L13.3327 7.33329"
					stroke="#64748B"
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path
					d="M9.33398 14.6666H14.6673"
					stroke="#64748B"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_55973_5048">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
}
